"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatterDate = void 0;
const React = require("react");
const react_1 = require("react");
class NumberFormatterDate extends react_1.Component {
    //   @observable
    //   public value: string;
    constructor(props) {
        super(props);
        // method working as a callable to update the value in the parent component
        this.invokeParentMethod = (event) => {
            const { value } = event.target;
            this.props.context.componentParent.dateMethodFromParent(value);
        };
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
    }
    render() {
        // if (this.props.colDef.headerName === "GROUP NAME") {
        //   const value = this.props.data.isDistributor;
        // }
        // Account for blank rows during row grouping
        if (this.props.value ||
            this.props.value === null) {
            //   const { value } = this.props;
            //   this.value = this.props.value;
            return (React.createElement("span", null,
                React.createElement("input", { type: "date", value: this.props.value || "", className: "ag-input", style: { height: "100%" }, onChange: this.invokeParentMethod })));
        }
        return React.createElement("span", null);
    }
}
exports.NumberFormatterDate = NumberFormatterDate;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter-date.tsx
// module id = 3562
// module chunks = 0